'use strict'

import Vue from 'vue'
import { createAuthGuard } from 'CommonApp/auth-guard-factory'

export const authGuard = createAuthGuard({
	loadConfig: () => {
		// Ensure conig load before accessing any route
		const config = Vue.e24Common.configService
		return config.load(config.APP)
	},
	buildEntryUrl: (to) => to.path,
	redirectParams: { goodbye: false, redirect: '', error: '' },
	syncProjectState: true
})



// WEBPACK FOOTER //
// ./src/app/auth-guard.js